import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getPermissions = store => store[NAME].data;
export const getEmployeesList = store => store[NAME].employeesList;
export const getTypes = store => store[NAME].types;
